import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import styled from "styled-components";

const StyledImageArea = styled.div`
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  margin: 20px;
`;

const ImagePreview = styled.img`
  max-width: 200px;
  height: auto;
  margin-top: 10px;
`;

function ImageUploader({ onImagesLoaded }) {
  const [images, setImages] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      const files = acceptedFiles.map((file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return new Promise((resolve) => {
          reader.onload = (event) => {
            resolve({ name: file.name, dataUrl: event.target.result });
          };
        });
      });

      Promise.all(files).then((loadedImages) => {
        setImages(loadedImages);
        onImagesLoaded(loadedImages);
      });
    }
  });

  return (
    <StyledImageArea {...getRootProps()}>
      <input {...getInputProps()} />
      <p>Drag 'n' drop some files here, or click to select files</p>
      {images.map((image, index) => (
        <ImagePreview key={index} src={image.dataUrl} alt={image.name} />
      ))}
    </StyledImageArea>
  );
}

export default ImageUploader;
